var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CoinEventHandler from './CoinEventHandler';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import DripEventHandler from './DripEventHandler';
import FacebookEventHandler from './FacebookEventHandler';
import GoogleEventHandler from './GoogleEventHandler';
import RedditEventHandler from './RedditEventHandler';
import SnapchatEventHandler from './SnapchatEventHandler';
import TiktokEventHandler from './TiktokEventHandler';
class UserEvents extends CoinUserEventHandlerBase {
    constructor(handlers) {
        super();
        this.handlers = handlers !== null && handlers !== void 0 ? handlers : [
            new CoinEventHandler(),
            new FacebookEventHandler(),
            new GoogleEventHandler(),
            new DripEventHandler(),
            new TiktokEventHandler(),
            new RedditEventHandler(),
            new SnapchatEventHandler(),
        ];
    }
    emailCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.emailCollected(fields)));
        });
    }
    accountCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.accountCreated()));
        });
    }
    shareCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.shareCompleted()));
        });
    }
    buyticketsCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.buyticketsCompleted()));
        });
    }
    installCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.installCompleted()));
        });
    }
    funnelCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.funnelCompleted()));
        });
    }
    offerRequested(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.offerRequested(fields)));
        });
    }
    feedbackScoreCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.feedbackScoreCollected(fields)));
        });
    }
    feedbackSourceCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.feedbackSourceCollected(fields)));
        });
    }
    goodFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.goodFeedbackRequested()));
        });
    }
    badFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.badFeedbackRequested()));
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.addToCart()));
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.initiateCheckout()));
        });
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.contactInfoComplete()));
        });
    }
    addressInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.addressInfoComplete()));
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.paymentInfoComplete()));
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.purchaseAttempted()));
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.purchaseFailed()));
        });
    }
    purchaseCompleted(payment) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.purchaseCompleted(payment)));
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.upsellViewed()));
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.upsellUnavailable()));
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.upsellAccepted()));
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.upsellSucceeded()));
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.upsellFailed()));
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.trialStarted()));
        });
    }
    funnelStarted(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.funnelStarted(fields)));
        });
    }
    testStarted(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.testStarted(fields)));
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.viewContent(fields)));
        });
    }
    userClick(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.handlers.map((handler) => handler.userClick(fields)));
        });
    }
    static get() {
        var _a;
        this.instance = (_a = this.instance) !== null && _a !== void 0 ? _a : new UserEvents();
        return this.instance;
    }
}
export default UserEvents;
//# sourceMappingURL=UserEvents.js.map